module.exports = __webpack_public_path__ + "media/images/logo-desk-fr-white-64d603fd6d942122a749d6a45677aae1.svg";